import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { SendPushNotificationRequest } from './push-notification.types';

import { requestSendPushNotification } from './push-notification.actions';

export const usePushNotificationApi = () => {
  const dispatch = useDispatch();

  const sendPushNotification = useCallback(
    (requestData: SendPushNotificationRequest) => {
      dispatch(requestSendPushNotification({ requestData }));
    },
    [dispatch]
  );

  return { sendPushNotification };
};
